import { DestroyRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

export interface StaticSvgIconProp {
  name: string;
  width: number;
  height: number;
  iconClass: string;
  pathClass: string;
  totalPath: number;
  path: string[];
  rect?: {
    x: number;
    y: number;
    width: number;
    height: number;
    rx?: number;
    fill?: string;
  };
}

export interface SvgIconProp {
  name: string;
  isDisabled: boolean;
  width: number;
  height: number;
  order?: number;
}

export interface FormConfig {
  fields: FormField[];
}

export interface FormField {
  id: string;
  type: string;
  label?: string;
  required?: boolean;
  pattern?: string;
  minValue?: number;
  maxValue?: number;
  options?: FieldOption[];
  patternError?: string;
  requiredError?: string;
  isDisableField?: boolean;
  allowNumeric?: boolean;
  noInitialWhiteSpace?: boolean;
  allowAlphabet?: boolean;
  allowAlphaNumeric?: boolean;
  allowAlphabetWithSpace?: boolean;
  allowAlphaNumericWithSpace?: boolean;
  allowAlphaNumericWithSpaceNoSpecialCharacter?: boolean;
  minError?: string;
  emailPatternError?: string;
  phonePatternError?: string;
  isCheckForMaxValue?: boolean;
  allowAlphaNumericWithDotUnderscoreDashSpecialCharacters?: boolean;
  fieldValue?: string;
  allowNumberWithFirstNonZeroNumber?: boolean;
  allowAlphabetWithHyphenSpace?: boolean;
  maxLength?: number;
  maxLengthError?: string;
  minLength?: number;
  minLengthError?: string;
  placeholder?: string;
}

export interface FieldOption {
  label: string;
  value: string;
}
export interface AddressProp {
  name: string;
  addressLine1: string;
  addressLine2?: string;
  state: string;
  city: string;
  postalCode: string;
  phone: string;
}

export class Claim {
  id: number | undefined;
  claim: string | undefined;
  value: string | undefined;
}

export interface IDropdownResponse {
  id: any;
  name: string;
  stateCode?: string;
  state?: string;
  country?: string;
  /** ISO 3166-1 alpha-3 (countries lookup only) */
  iso3?: string;
  isDefault?: boolean;
  isFavorite?: boolean;
  cityName?: string;
  cityCode?: string;
  city?: string;
  displayId?: string;
}

export interface ILookupDropdownResponse {
  statusCode: number;
  message: string;
  data: IDropdownResponse[];
}

export interface ModalButton {
  id: string;
  label: string;
  class: string;
}

export interface AutocompleteConfig {
  dropdownResponse: IDropdownResponse[];
  formName: FormGroup;
  controlName: string;
  apiControlName: string;
  param: string;
  formControlId?: string;
  destroyRef?: DestroyRef;
}

export interface CommercialInvoiceTotalData {
  description: string;
  hsCode: string;
  htsCode?: string;
  quantity: string;
  weight: string | number;
  value: string;
  countryCode: string;
  itemNumber: string;
}

export interface InvoiceAddressDetails {
  id?: string;
  name: string;
  companyName?: string;
  phone?: string;
  address_1: string;
  address_2?: string;
  city: string;
  state: string;
  zipCode: string;
  type?: string;
  countryCode: string;
  country?: string;
}

export interface InvoiceDetails {
  [key: string]: any;
  date: string; 
  billNumber: string;
  notes: string;
}

export interface UserProfileInfo {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  accountId: number;
  accountNumber: string;
  accountName: string;
  measurementOptions: string;
  fullName?: string;
}
